export const sessionMainQueryKey = "sessions";
